"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2c2.5257 0 5.6839 2 5.6839 4.586 0 1.0217-.472 1.7665-1.184 2.414 1.5549 1.0935 3.4999 2 3.4999 4 0 1.5986-1.3645 2.2549-1.3647 3.5002-.0002 1.391 1.7393 1.9387 1.0333 3.7397C19.2658 21.2673 18.3703 22 17 22c-2 0-3.0001-1-4.9999-1C9.9999 21 8.7156 22 7 22c-1.3703 0-2.2657-.7327-2.6684-1.7601-.706-1.801 1.0335-2.3487 1.0333-3.7397C5.3647 15.2549 4 14.5 4 13c0-2 1.9455-2.9068 3.5-4-.712-.6475-1.1838-1.3923-1.1838-2.414C6.3162 4 9.4743 2 12 2zM8.3129 6.586C8.313 7.5 9.6328 8 9.6328 9c0 2-3.6439 2-3.6328 4 .0055 1 1.3647 2 1.3649 3.4998.0002 1.4999-1.53 2.0948-1.1712 3.0103C6.667 20.7178 9.032 19 12 19c2.9679 0 5.3329 1.7178 5.8063.5101.3589-.9155-1.1712-1.5104-1.1712-3.0103C16.6352 15 17.9998 14 17.9999 13c.0001-2-3.6327-2-3.6327-4 0-1 1.32-1.5 1.32-2.414C15.6872 5 14.0001 4 12.0001 4 10 4 8.3129 5 8.3129 6.586z"
  })];
};

exports.default = _default;